import { useRef, useEffect } from 'react';

function CookiePolicy() {
  const divRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!divRef.current) return;
    const scriptTwo = document.createElement('script');
    scriptTwo.type = 'text/javascript';
    scriptTwo.innerHTML = `OneTrust.NoticeApi.Initialized.then(function() {
        OneTrust.NoticeApi.LoadNotices(["https://privacyportal-cdn.onetrust.com/storage-container/73dca12b-5ba4-4937-9072-b5ffa15d1ba7/privacy-notices/13a11209-d51b-4913-9834-633870b50ddb/published/privacynotice.json"]);
      });`;
    divRef.current.appendChild(scriptTwo);
  }, []);

  return (
    <div ref={divRef}>
      {/*<!-- OneTrust Privacy Notice start -->
      <!-- Language Drop-down element that will control in which language the Privacy Notice is displayed -->*/}
      <div className="ot-privacy-notice-language-dropdown-container"></div>
      {/* <!-- Container in which the Privacy Notice will be rendered --> */}
      <div
        id="otnotice-13a11209-d51b-4913-9834-633870b50ddb"
        className="otnotice"
      ></div>

      {/* <!-- OneTrust Cookies List start --> */}
      <div id="ot-sdk-cookie-policy"></div>
      {/* <!-- OneTrust Cookies List end --> */}
    </div>
  );
}

export default CookiePolicy;
